import Request from 'admin/lib/adminRequest';

export default {
    list: async ({ query, id, pagination = { page: 1, pageSize: 0 } }) => {
        const { page, pageSize: limit } = pagination;

        try {
            const [categoriesRes, selectedRes] = await Promise.all([
                Request.postJSON('admin/project/listCategories', {
                    query,
                    limit,
                    page
                }),
                Request.postJSON('admin/project/listCategories', {
                    id: id === undefined ? [] : id
                })
            ]);

            if (categoriesRes.error || selectedRes.error) {
                throw new Error(categoriesRes.msg || selectedRes.msg);
            }

            const categories = { data: categoriesRes.data, count: categoriesRes.count };
            const selected = { data: selectedRes.data };

            selected.data.forEach(itemSelected => {
                const item = categories.data.find(
                    itemCategory => itemSelected.id === itemCategory.id
                );
                if (!item) {
                    categories.data.push({
                        ...itemSelected,
                        missingSelected: true
                    });
                }
            });

            return categories;
        } catch (err) {
            console.error(err);
        }
    }
};
